import constants from 'common/constants'
import {
  GET_TIMETABLE_CATEGORIES,
  GET_TIMETABLE_SUBCATEGORIES,
  GET_TIMETABLE_SUBCATEGORY_BY_ID,
  ADD_CONSTRAINT_BY_ID,
  GET_ALL_CONSTRAINTS,
  DELETE_CONSTRAINT,
  GET_CONSTRAINT_BY_ID,
  UPDATE_CONSTRAINT,
  GET_TIMETABLE,
  DELETE_TIMETABLE,
  GET_TIMETABLE_REPORT,
  GET_TIMETABLE_STATUS,
  LOG_SOCKET_MESSAGE,
} from './ActionTypes/ApiActionTypes'
import {
  REDUX_GET_ALL_CONSTRAINTS,
  REDUX_GET_TIMETABLE_CATEGORIES,
  REDUX_GET_TIMETABLE_SUBCATEGORIES,
  REDUX_GET_TIMETABLE_SUBCATEGORY_BY_ID,
  REDUX_GET_CONSTRAINT_BY_ID,
} from './ActionTypes/ReduxActionTypes'

export const getTimetableCategories = (data, onSuccess, onFailure, reduxUpdate = false) => {
  return {
    type: GET_TIMETABLE_CATEGORIES,
    payload: {
      apiUrl: constants.api_get_timetable_categories,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      body: data,
      reduxActionType: reduxUpdate ? REDUX_GET_TIMETABLE_CATEGORIES : '',
      onSuccess,
      onFailure,
    },
  }
}

export const getTimetableSubCategories = (data, onSuccess, onFailure, reduxUpdate = false) => {
  return {
    type: GET_TIMETABLE_SUBCATEGORIES,
    payload: {
      apiUrl: constants.api_get_timetable_subcategories,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      body: data,
      reduxActionType: reduxUpdate ? REDUX_GET_TIMETABLE_SUBCATEGORIES : '',
      onSuccess,
      onFailure,
    },
  }
}

export const getTimetableSubCategoriesByID = (data, onSuccess, onFailure, reduxUpdate = false) => {
  return {
    type: GET_TIMETABLE_SUBCATEGORY_BY_ID,
    payload: {
      apiUrl: constants.api_get_timetable_subcategories,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: reduxUpdate ? REDUX_GET_TIMETABLE_SUBCATEGORY_BY_ID : '',
      onSuccess,
      onFailure,
    },
  }
}

export const addConstraint = (id, body, onSuccess, onFailure) => {
  return {
    type: ADD_CONSTRAINT_BY_ID,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_add_constraint,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}

export const getAllConstraints = (body, onSuccess, onFailure, reduxUpdate = false) => {
  return {
    type: GET_ALL_CONSTRAINTS,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_get_all_constraints,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: reduxUpdate ? REDUX_GET_ALL_CONSTRAINTS : '',
      onFailure,
    },
  }
}

export const deleteConstraint = (id, onSuccess, onFailure) => {
  return {
    type: DELETE_CONSTRAINT,
    payload: {
      apiUrl: constants.api_delete_constraint(id),
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getConstraintById = (body, onSuccess, onFailure, reduxUpdate = false) => {
  return {
    type: GET_CONSTRAINT_BY_ID,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_get_timetable_constraints,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: reduxUpdate ? REDUX_GET_CONSTRAINT_BY_ID : '',
      onFailure,
    },
  }
}

export const updateConstraint = (id, body, onSuccess, onFailure) => {
  return {
    type: UPDATE_CONSTRAINT,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_update_constraint(id),
      getString: '',
      useBaseURL: true,
      requestType: 'PUT',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}

export const generateTimetable = (body, onSuccess, onFailure, reduxUpdate = false) => {
  return {
    type: GET_TIMETABLE,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_get_timetable,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      body,
      header: 'application/json',
      reduxActionType: '',
      onFailure,
    },
  }
}

export const requestTimetable = (body, onSuccess, onFailure) => {
  return {
    type: GET_TIMETABLE,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_request_timetable,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: body,
      reduxActionType: '',
      onFailure,
    },
  }
}

export const deleteTimetable = (onSuccess, onFailure) => {
  return {
    type: DELETE_TIMETABLE,
    payload: {
      onSuccess: onSuccess,
      apiUrl: constants.api_delete_timetable,
      getString: '',
      useBaseURL: true,
      requestType: 'DELETE',
      header: 'application/json',
      reduxActionType: '',
      onFailure,
    },
  }
}

export const getTimetableReport = (onSuccess, onFailure) => {
  return {
    type: GET_TIMETABLE_REPORT,
    payload: {
      apiUrl: constants.api_get_timetable_report,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const getTimetableStatus = (onSuccess, onFailure) => {
  return {
    type: GET_TIMETABLE_STATUS,
    payload: {
      apiUrl: constants.api_get_timetable_status,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}

export const logSocketMessage = (data, onSuccess, onFailure) => {
  return {
    type: LOG_SOCKET_MESSAGE,
    payload: {
      apiUrl: constants.api_socket_message_log,
      getString: '',
      useBaseURL: true,
      requestType: 'POST',
      header: 'application/json',
      body: data,
      reduxActionType: '',
      onSuccess,
      onFailure,
    },
  }
}
